//dependencies
import $ from "jquery";

export default function() {

    function initScript() {

        // Initial Load
        getNewsData();

        // Filter changes
        $("ul#newsTopics .newsTopic").on("click", function(e){
            e.preventDefault();
            var topic = $(this).data("topic");
            $("#hdnTopic").val(topic);
            getNewsData();
        });

        $("body").on("click", 'a.pageLink', function(e){
            e.preventDefault();
            var page = $(this).data("page");
            $("#hdnPage").val(page);
            // Get the height of the navigation element.
            var navigationHeight = $("#header").height();
            var callback = function () {
                 $('html, body').animate({
                     scrollTop: $("#newsResultsSection").offset().top - (navigationHeight + 50)
                 });
            };
            
            getNewsData(callback);

           
        });
    }

    function getNewsData(callback)
    {
        var featuredPage = "";
        var hdnFeaturedPageInput = $("#hdnFeaturedPage");
        if(hdnFeaturedPageInput.length > 0)
        {
            featuredPage = hdnFeaturedPageInput.val();
        }

        $.ajax({
            url: window.curry.newsFeed,
            type: "GET",
            data: {
                topic: $("#hdnTopic").val(),
                page: $("#hdnPage").val(),
                featuredPage: featuredPage
            },
            success: function (response) {
                $("#newsResults").html(response);
                if(callback){
                    callback();
                }
            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    initScript();
}


// WEBPACK FOOTER //
// ./src/ui/js/apps/news.js